import { type ResourceId } from '../common/structs';

export const transfers = () => ({
    collection: () => ({
        transfers: `/transfers`,
        transfers_incoming: `/transfers/incoming`,
    }),
    single: (id: ResourceId) => ({
        single: `/transfers/${id}`,
        sender_accept: `/transfers/${id}/sender_accept`,
        receiver_accept: `/transfers/${id}/receiver_accept`,
        resend_code: `/transfers/${id}/resend_code`,
    }),
});
